export default "__VITE_ASSET__B5Vl_qm$__"